import request from '@/config/axios'
import type { PageParam } from '@/types/common'
import type { PageResult } from '@/api/lawyer'

export interface FirmTaskVO {
  id?: number
  caseId: number
  title: string
  content?: string
  assigneeLawyerId: number
  assigneeLawyerName?: string
  dueDate?: string
  status?: string
  caseTitle?: string
  firmCaseNo?: string
}

export interface FirmTaskPageReq extends PageParam {
  caseId?: number
  assigneeLawyerId?: number
  status?: string
  overdueOnly?: boolean
}

export const FirmTaskApi = {
  create: (data: FirmTaskVO) => request.post({ url: '/lawyer/firm/task/create', data }),
  update: (data: FirmTaskVO) => request.put({ url: '/lawyer/firm/task/update', data }),
  delete: (id: number) => request.delete({ url: '/lawyer/firm/task/delete?id=' + id }),
  page: (params: FirmTaskPageReq) =>
    request.get<PageResult<FirmTaskVO>>({ url: '/lawyer/firm/task/page', params }),
  complete: (id: number) => request.put({ url: '/lawyer/firm/task/complete?id=' + id }),
  cancel: (id: number) => request.put({ url: '/lawyer/firm/task/cancel?id=' + id })
}
